import React from 'react';
import logo from '../../assets/img/logo-full.svg'

const Logo = () => (
    <img style={{maxWidth:'100%'}} src={logo} alt="logo changerdevie" />
);

export default Logo;
